var n = 9007199254740991;
function r(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= n;
}
export {
  r as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/isLength.js
// module id = 452
// module chunks = 41